// extracted by mini-css-extract-plugin
export var card = "_8n-0";
export var failedIcon = "_8n-4";
export var failedIconBadge = "_8n-3";
export var icon = "_8n-1";
export var successIcon = "_8n-2";